import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-8 w-full p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "font-semibold text-lg" }, "Schedule a meeting", -1)
const _hoisted_3 = { class: "flex relative w-full h-auto" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "w-full flex-row mt-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, [
    /*#__PURE__*/_createTextVNode("Title "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
  ])
], -1)
const _hoisted_8 = { class: "w-full flex-row mt-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, [
    /*#__PURE__*/_createTextVNode("URL "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
  ])
], -1)
const _hoisted_10 = { class: "w-full flex flex-row mt-6 justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_TextField, {
              label: "",
              placeholder: "Title",
              typeInput: "text",
              name: "title",
              floatingInput: true
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_TextField, {
              label: "",
              placeholder: "www.meeting-url.com",
              typeInput: "text",
              name: "meeting_url",
              floatingInput: true
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Button, {
              variant: "contained",
              label: _ctx.meetingId ? 'Edit' : 'Save',
              onClick: _ctx.onSubmit,
              disabled: !_ctx.meta.valid || _ctx.isLoading
            }, null, 8, ["label", "onClick", "disabled"])
          ])
        ])
      ])
    ])
  ]))
}